export const STUDENT_MODULE = {
  CARD: 'student_card', // 签到
  COUPON: 'student_coupon', // 任务

};

export const STUDENT_MODULE_COMPONENT = {
  [STUDENT_MODULE.CARD]: 'cards', // 签到
};

export const STUDENT_AUTH_STATUS = {
  UNKNOWN: -1, // 未知
  NEVERAUTH: 0, // 未认证
  AUDITING: 1, // 审核中
  PASSED: 2, // 已通过
  NOPASS: 3, // 未通过
};

export const BIZ = [
  { name: '单车学生价', desc: '月卡9.9元起', icon: 'https://m.hellobike.com/resource/helloyun/07177/45GDkZdg5O.png?x-oss-process=image/quality,q_80' },
  { name: '吃喝团购', desc: '享更低折扣', icon: 'https://m.hellobike.com/resource/helloyun/07177/vUoXw5Y6Nr.png?x-oss-process=image/quality,q_80' },
  { name: '酒店8折起', desc: '最高立减20元', icon: 'https://m.hellobike.com/resource/helloyun/07177/DO11xch4XO.png?x-oss-process=image/quality,q_80' },
  { name: '火车学生票', desc: '学生价立减', icon: 'https://m.hellobike.com/resource/helloyun/07177/Ov_Az-BoRO.png?x-oss-process=image/quality,q_80' },
  { name: '顺风车特惠', desc: '专属特惠券', icon: 'https://m.hellobike.com/resource/helloyun/07177/j1-BqASQpS.png?x-oss-process=image/quality,q_80' },
];
